import React from 'react'
import Layout from './layout'


const Mdx = ({ children }) => {
    return <Layout ><article>{children}</article></Layout>
}

export default Mdx